export const CommentActionTypes = {
  API_RESPONSE_SUCCESS: '@@comment/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@comment/API_RESPONSE_ERROR',
  GET_COMMENT: '@@comment/GET_COMMENT',
  GET_COMMENT_BY_ID: '@@/GET_COMMENT_BY_ID',
  ADD_COMMENT: '@@comment/ADD_COMMENT',
  UPDATE_COMMENT: '@@comment/UPDATE_COMMENT',
  DELETE_COMMENT: '@@comment/DELETE_COMMENT',
  RESET_COMMENT: '@comment/RESET_COMMENT',
};